import {Injectable} from '@angular/core';

@Injectable()
export class DanamonModel {
    vaNumber: any;
    customerName: any;
    binNo: any;
    binTitle: any;
    currency: any;
    billAmount: any;
    payAmount: any;
}
